module.exports = require("json-pointer");